export function VisibilityProvider({ visible, children }) {
  if (!visible) {
    return null
  }

  return children
}
